import React, { useCallback, useEffect } from 'react';
import { View } from 'react-native';
import {
  Button,
  Text,
  Banner,
  KeyboardScreenContainer,
  Input,
  Checkbox,
} from '~/components';
import * as yup from 'yup';
import { isCpf } from '~/utils/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useRoute, type RouteProp } from '@react-navigation/native';
import type { RootStackParamList } from '~/navigation/types';
import { LocalStorage } from '~/storage/LocalStorage';
import { ANONYMOUS_USER } from '~/storage/constants';
import useAppNavigation from '~/hooks/useAppNavigation';
import { useSalesFunnel } from '~/stores';

interface FormData {
  document: string;
  isNotInsured: boolean;
}

export const schema = yup
  .object()
  .shape({
    document: isCpf(),
    isNotInsured: yup.bool(),
  })
  .required();

const NoAuthContractPage: React.FC = () => {
  const { navigate } = useAppNavigation();
  const { newStepLog } = useSalesFunnel();

  const { params } =
    useRoute<
      RouteProp<RootStackParamList, 'MarisaServicos_NoAuthContractPage'>
    >();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues: { isNotInsured: false },
  });

  const onSubmit = useCallback(
    async (data: FormData) => {
      await LocalStorage.set(ANONYMOUS_USER, data);
      navigate(params.navigateTo as any);
    },
    [navigate, params.navigateTo]
  );

  useEffect(() => {
    newStepLog('CPF-USUARIO');
  }, [newStepLog]);

  return (
    <View className="flex-1 bg-light-100">
      <KeyboardScreenContainer>
        <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
          <Banner type={params.type} />

          <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
            <Text className="text-xl mb-4 text-gray-600">
              Dados da contratação
            </Text>

            <Text className="text-gray-400 text-sm mb-8">
              Para seguirmos com a contratação, precisamos que informe o CPF do
              contratante e/ou o CPF de quem vai receber o serviço
            </Text>

            <Input
              control={control}
              label="Informe o seu CPF"
              name="document"
              placeholder="Informe o seu CPF"
              keyboardType="number-pad"
              error={errors.document?.message}
              maskConfig={{ type: 'cpf' }}
              className={!errors.document?.message ? 'mb-[-20px]' : 'mb-2'}
            />

            <Checkbox
              control={control}
              name="isNotInsured"
              error={errors.isNotInsured?.message}
            >
              O seguro é para outra pessoa?
            </Checkbox>

            <View className="flex-1 justify-end">
              <Button className="w-full" onPress={handleSubmit(onSubmit)}>
                CONTINUAR
              </Button>
            </View>
          </View>
        </View>
      </KeyboardScreenContainer>
    </View>
  );
};

export default NoAuthContractPage;
